// extracted by mini-css-extract-plugin
export default {"header":"Modal_header__MJoso","body":"Modal_body__+z+iV"};